import forge from 'node-forge';

import { billersSelectors } from 'app-components/flux/billers';
import { getLogger } from 'app-components/utils/core';
import store from 'app-components/utils/redux-store';

const log = getLogger('data/billerLogins/encryption');

export const encryptBillerLoginCredentials = (billerLogin) => {
  const { credentials, credentialAnswers = [], providerBillerID } = billerLogin;
  let isSecure = false;
  const encryptedCredentials = [...credentialAnswers];

  const biller = billersSelectors.getBiller(store.getState(), providerBillerID);

  if (biller && biller.fieldEncryption) {
    const { algorithm, id } = biller.fieldEncryption;
    try {
      if (algorithm === 'RSA') {
        const passwordIndex = credentials.findIndex((cred) => cred.type === 'PASSWORD');
        const password = credentialAnswers[passwordIndex];
        if (password) {
          const pem = `-----BEGIN PUBLIC KEY-----${biller.fieldEncryption.publicKey}-----END PUBLIC KEY-----`;
          const publicKey = forge.pki.publicKeyFromPem(pem);
          const encryptedValue = publicKey.encrypt(forge.util.encodeUtf8(password));
          encryptedCredentials[passwordIndex] = btoa(encryptedValue);
          isSecure = true;
        }
      }
    } catch (error) {
      log.log('Error encrypting billerLogin credentials, error=', error);
      isSecure = false;
    }
    return { encryptedCredentials, isSecure, fieldEncryptionId: id };
  }
  return { encryptedCredentials: billerLogin.credentialAnswers, isSecure: false, fieldEncryptionId: null };
};
